import styled from 'styled-components';

export default {
  Delimiter: styled.div`
    height: ${props => props.theme.spacing.sm};
    width: 1px;
    background-color: ${props => props.theme.colors.handler};
  `
};
